<div class="dialog full-width-important">
  <mat-icon class="warning-icon secondary-color">error_outline</mat-icon>
  <p class="bigger align-center">
    weet u zeker dat u deze rabobank-rekening<br>
    handmatig wil toevoegen?
  </p>
  <small>
    deze bank wordt door reveon ondersteund en kan
    worden toegevoegd door <a class="link" (click)="import()">CSV-bestanden te importeren</a>
    <br>
    bekijk de
    <a class="link" href="https://www.reveon.nl/help/inlezen-banktransacties/" target="_blank">handleiding</a>
    of neem contact op via het
    <a class="link" href="https://app.reveon.nl/#/contact" target="_blank">contactformulier</a>
  </small>
  <div class="space-around flex">
    <button class="block float-left btn-left btn arrow-left" (click)="cancel()">annuleer</button>
    <button class="block float-right btn glasses " (click)="import()">banktransacties importeren</button>
    <button class="block float-right btn inverted plus" (click)="add()">rekening toevoegen</button>
  </div>
</div>
